import { Emoji } from '@gitbook/spine-react';
import { type EmojiDef, emojisByCode, searchEmojis } from '@gitbook/util-emojis';

import { createPalette } from '../transforms';
import type { PaletteDef } from '../types';

/**
 * List of top emojis to suggest to users.
 */
const EMOJIS_SUGGESTION: EmojiDef[] = [
    emojisByCode['1f44d'], // 👍
    emojisByCode['1f389'], // 🎉
    emojisByCode['1f604'], // 😄
    emojisByCode['1f602'], // 😂
    emojisByCode['1f44f'], // 👏
    emojisByCode['1f44e'], // 👎
];

/**
 * Create a commands palette to pick an emoji.
 */
export function createPickEmojiPalette(
    pick: (code: string) => void,
    options: {
        /**
         * Maximum number of emojis shown as suggestions
         */
        max?: number;

        /**
         * Palette options.
         */
        withSearch?: boolean;
    } = {}
): PaletteDef {
    const { withSearch = true, max = 5 } = options;

    return createPalette({
        search: withSearch ? { placeholder: 'Select an emoji…' } : undefined,
        groups: [
            {
                key: 'emojis',
                commands: (palette) => {
                    const emojis = palette.query.text
                        ? searchEmojis(palette.query.text)
                        : EMOJIS_SUGGESTION;

                    return emojis.slice(0, max).map((emoji) => {
                        return {
                            key: emoji.code,
                            title: emoji.shortname,
                            icon: <Emoji code={emoji.code} />,
                            trigger: () => pick(emoji.code),
                        };
                    });
                },
            },
        ],
    });
}
